import Grid from "@material-ui/core/Grid";
import React, { useEffect, useState } from "react";
import FileField from "../../../components/FileField";
import ActivePhoto from "./ActivePhoto";
import PhotoList from "./PhotoList";

const Photos = ({uploadPhoto}) => {
  const [photos, setPhotos] = useState<any>([])
  const [active, setActive] = useState<any>(undefined)

  const photoChange = (addedFiles: File[]) => {

    setPhotos([...photos, ...addedFiles.map((file, index) => ({
        file,
        isMain: photos.length === 0 && index === 0 ? true : undefined,
      }))].map((e, index) => {e.index = index; return e}))
  }

  const handlerRemove = (removeItem) => {
    let result = photos.filter(e => e.index != removeItem).map((e, index) => {e.index = index; return e});
    
    if (!result.some(e => e.isMain) && result.length > 0) {
      result[0].isMain = true;
    }

    setPhotos(result);    
  }
  
  const activePhotoIndex = (itemIndex) => {
    setActive(photos.find(e => e.index == itemIndex))
  }

  useEffect(() => {
    uploadPhoto(photos)
  }, [photos])
  
  return (
    <>
      <Grid container spacing={2}>
        {photos.length > 0 ? (
          <Grid item xs={12} sm={6} md={12}>
            <ActivePhoto 
              photos={photos} 
              photo={active || photos.find(e => e.isMain)}
              handlerMarkMain={(index) => setPhotos(photos.map(e => {e.index == index? e.isMain = true: e.isMain = undefined; return e}))}
              handlerRemove={(index) => handlerRemove(index)}
              />
          </Grid>
        ) : null}
        <Grid item xs={12} sm={photos.length > 0 ? 6 : 12} md={12}>
          <Grid container spacing={2}>
            {photos.length > 0 ? (
              <Grid item xs={12}>
                <PhotoList photos={photos} activePhotoIndex={activePhotoIndex} active={active?.index || photos.find(e => e.isMain).index} />
              </Grid>
            ) : null}
            <Grid item xs={12}>
              <FileField
                accept={"image/*"}
                onChange={photoChange}
                multi
                text={"Выберите или перетащите сюда фотографии"}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default Photos